import React, {createContext, useReducer} from 'react'
import {DepartFilterReducer} from "../reducers/DepartFilterReducer";
import {saveFilterState} from "../../util/Util";
import {DEPART_FILTER_STATE_KEY} from "../../util/LocalStorageKeys";

export const DepartFilterContext = createContext();

const DepartFilterContextProvider = (props) => {
    let initialState = {
        xptNodes: null,
        departure: [],
        driverType: [],
        cluster: [],
        status: [],
        departByTime: [],
        data: {
            xptNodes: [],
            departure: [],
            driverType: [],
            cluster: [],
            departByTime: []
        }
    }
    const urlState = props.context ? JSON.parse(props.context.replace('%2f', '/')) : null;
    if (urlState) {
        initialState = {...initialState, ...urlState};
        saveFilterState(DEPART_FILTER_STATE_KEY, initialState);
    }

    const [viewModelF, dispatchF] = useReducer(DepartFilterReducer, initialState);
    return (
        <DepartFilterContext.Provider value={{viewModelF, dispatchF}}>
            {props.children}
        </DepartFilterContext.Provider>
    )
}

export default DepartFilterContextProvider


// WEBPACK FOOTER //
// ./src/components/depart/context/DepartFilterContext.js